<template>
  <div class="row" :class="{ 'company-main': true, isHovered: isHovered }">
    <div class="col">
      <div class="logo-container">
        <router-link to="/"
          ><Logo class="logo" :class="{ white: isHovered }"
        /></router-link>
      </div>
      <div class="content">
        <ul
          class="companies-list"
          @mouseenter="mouseenter"
          @mouseleave="mouseleave"
        >
          <company-item
            v-for="(company, index) in companies"
            :key="index"
            :company="company"
          ></company-item>
        </ul>
      </div>
      <ContentFooter />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Logo from "./Logo.vue";
import ContentFooter from "./ContentFooter";

Vue.component("company-item", {
  template: `
      <li
        class="company-item"
        @mouseenter="mouseenter"
        @mouseleave="mouseleave">
        <router-link :to="path" class="company-item-link">{{company.name}}</router-link>
      </li>
    `,
  props: {
    company: Object,
    name: String,
    img: String
  },
  computed: {
    path: function() {
      return `/companies/${this.company.slug}`;
    }
  },
  data: function() {
    return {
      isHovered: false
    };
  },
  methods: {
    mouseenter: function(e) {
      this.$root.setBackground(this.company.img);
    },
    mouseleave: function(e) {}
  }
});

export default {
  name: "Companies",
  components: {
    Logo,
    ContentFooter
  },
  props: {
    companies: Array
  },
  data() {
    return {
      msg: "",
      isHovered: false,
      isWhite: false
    };
  },
  methods: {
    mouseenter: function(e) {
      this.isHovered = true;
    },
    mouseleave: function(e) {
      this.isHovered = false;
      this.$root.setBackground("");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$root.setBackground("");
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";
.isHovered {
  color: $color-white;
}
.companies-list {
  list-style: none;
  text-align: center;
  font-size: 4.2rem;
  line-height: 2;
  margin: 0;
  padding: 0;
}

.company-item {
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.company-item-link {
  text-decoration: none;
  display: block;

  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Companies.vue